import { JSX } from 'solid-js';

import { SignalLike, useBind } from '../contexts';

// type NotFunction = Exclude<any, (...args: any[]) => any>;
type NotFunction<T> = T extends (...args: any[]) => any ? never : T;

// export type DistributeSignal<T> = T extends any ? SignalLike<T> : never;
export interface SingleProps<T> extends JSX.HTMLAttributes<HTMLElement> {
  value: T;
  checked?: boolean;
  disabled?: boolean;
  bind?: SignalLike<NotFunction<T> | undefined>;
  onItemClick?: () => void;
}

export type SingleBind = [Accessor<boolean>, () => void, JSX.HTMLAttributes<HTMLElement>];

/** 单个绑定 */
export function createSingleBind<T>(props: SingleProps<T>): SingleBind {
  const others = splitBindProps(props);
  const ctx = useBind(props.bind);
  // const [, close] = useToggle();
  ctx.addItem(() => props.value);

  // 这个逻辑在SSR的时候经常会出错，所以，可能建议不要默认值
  // if (props.checked && ctx.value === undefined) {
  //   ctx.toggle(props.value)
  // }
  const selected = createMemo(() => ctx.value === props.value);
  /** 销毁时如果当前被选中，取消选中 */
  // onCleanup(() => {
  //   if (selected() && !ctx.items.has(props.value)) {
  //     const value = ctx.items.values().next().value;
  //     console.log(value)
  //     value!==undefined && ctx.toggle(value);
  //   }
  // });

  return [
    selected,
    () => {
      if (!props.disabled) {
        ctx.toggle(props.value);
      }
    },
    others,
  ];
}

export function splitBindProps<T>(props: SingleProps<T>): JSX.HTMLAttributes<HTMLElement> {
  const [, others] = splitProps(props, ['value', 'bind', 'class', 'children']);
  return others;
  // // const bind = props.bind || useBind();
  // if (!bind) {
  //   return [ others, bind ];
  // }
  // return [ others, bind ];
}
